import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DASHBOARD_TAB_SLUGS } from '../../constants/dashboard-constants';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { appendParamsToQueryString } from '../../utils/filters-util';
import { fetchDashboardDataApi } from '../../api/dashboard-api';

const useMetricsData = ({
  dashboardType = DASHBOARD_TAB_SLUGS.PERFORMANCE_TAB,
  subDashboardType = '',
  paramsObj = {},
}) => {
  const location = useLocation();
  const [pagination, setPagination] = useState({});
  const [metricsData, setMetricsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pending, setPending] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const hasMore = pagination?.page < pagination?.pages;

  const fetchData = async ({ page = 1, append = false } = {}) => {
    append ? setLoadingMore(true) : setPending(true);
    try {
      var updatedSearchQuery = appendParamsToQueryString('tab', dashboardType, location.search);
      updatedSearchQuery = !!subDashboardType
        ? appendParamsToQueryString('subtab', subDashboardType, updatedSearchQuery)
        : updatedSearchQuery;
      const res = await fetchDashboardDataApi(updatedSearchQuery, page > 1 ? { ...paramsObj, page } : paramsObj);
      if (res && res?.status) {
        setMetricsData((prev) => (append ? [...(prev || []), ...(res?.data ?? [])] : (res?.data ?? [])));
        setPagination(res?.meta?.pagination || {});
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setLoading(false);
      append ? setLoadingMore(false) : setPending(false);
    }
  };

  const loadMore = () => {
    if (!hasMore || loadingMore || pending) return;
    fetchData({ page: pagination?.page + 1, append: true });
  };

  const changePage = (page) => {
    if (pending || page === pagination?.page) return;
    fetchData({ page });
  };

  useEffect(() => {
    if (location.search) {
      fetchData();
    }
  }, [location.search, JSON.stringify(paramsObj)]);

  return {
    pagination,
    metricsData,
    loading,
    pending,
    hasMore,
    loadingMore,
    loadMore,
    changePage,
    refetch: fetchData,
  };
};

export default useMetricsData;
